import {FETCH_QUESTION_TYPE_REQUEST,FETCH_QUESTION_TYPE_SUCCESS,FETCH_QUESTION_TYPE_ERROR,
    FETCH_EMOJI_REQUEST,FETCH_EMOJI_SUCCESS,FETCH_EMOJI_ERROR,
    INSERT_QUESTIONS_DETAILS_REQUEST,INSERT_QUESTIONS_DETAILS_SUCCESS,INSERT_QUESTIONS_DETAILS_ERROR,
    FETCH_FEEDBACK_QUES_ANS_LIST_REQUEST,FETCH_FEEDBACK_QUES_ANS_LIST_SUCCESS,
    UPDATE_QUESTION_DETAILS_SETTINGS_REQUEST,UPDATE_QUESTION_DETAILS_SETTINGS_SUCCESS,
    DELETE_QUESTION_DETAILS_REQUEST,DELETE_QUESTION_DETAILS_SUCCESS,
    FETCH_FEEDBACK_TYPES_REQUEST, FETCH_FEEDBACK_TYPES_SUCCESS} from '../action/feedbackSettingAction';
import {feedbackSettingState} from '../state/feedbackSettingState';
var intialStatusCode=''
export function feedbackSettingReducer(state = feedbackSettingState, action) {
    switch (action.type) { 
        case FETCH_QUESTION_TYPE_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:intialStatusCode
            })
        case FETCH_QUESTION_TYPE_SUCCESS:            
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                questionType: action.questionType
            })
        case FETCH_QUESTION_TYPE_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            }) 
            case FETCH_EMOJI_REQUEST:
                return Object.assign({}, state, {
                    isLoading: action.isLoading,
                    statusCode:intialStatusCode
                })
            case FETCH_EMOJI_SUCCESS:            
                return Object.assign({}, state, {
                    isLoading: action.isLoading,
                    emojiImage: action.emojiImage
                })
            case FETCH_EMOJI_ERROR:
                return Object.assign({}, state, {
                    errorNumber: action.errorNumber,
                    errorMessage: action.errorMessage
                })
        case INSERT_QUESTIONS_DETAILS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:intialStatusCode
            })
        case INSERT_QUESTIONS_DETAILS_SUCCESS:            
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                questionList: action.questionList,
                messageLabel: action.messageLabel,
                statusCode:action.statusCode
                
            })
        case INSERT_QUESTIONS_DETAILS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            }) 
            case FETCH_FEEDBACK_QUES_ANS_LIST_REQUEST:
                return Object.assign({}, state, {
                    isLoading: action.isLoading,
                    statusCode:intialStatusCode
                })
            case FETCH_FEEDBACK_QUES_ANS_LIST_SUCCESS:            
                return Object.assign({}, state, {
                    isLoading: action.isLoading,
                    questionList: action.questionList
                })  
                case UPDATE_QUESTION_DETAILS_SETTINGS_REQUEST:
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
                        statusCode:intialStatusCode
                    })
                case UPDATE_QUESTION_DETAILS_SETTINGS_SUCCESS:            
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
                        questionList: action.questionList,
                        messageLabel: action.messageLabel,
                        statusCode:action.statusCode  
                    })    
                    case DELETE_QUESTION_DETAILS_REQUEST:
                        return Object.assign({}, state, {
                            isLoading: action.isLoading,
                            statusCode:intialStatusCode
                        })
                    case DELETE_QUESTION_DETAILS_SUCCESS:
                        return Object.assign({}, state, {
                            isLoading: action.isLoading,
                            questionList: action.questionList,
                            messageLabel: action.errorMessage,
                            statusCode:action.statusCode
                        })
                case FETCH_FEEDBACK_TYPES_REQUEST:
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
                        statusCode: intialStatusCode
                    })
                case FETCH_FEEDBACK_TYPES_SUCCESS:
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
                        FeedbackTypesList: action.FeedbackTypesList
                    })

                    
        default:
            return state;
    }
}
